export const formatDate = (date: string) => {
  return new Date(date).toLocaleString(
    'en-IN',
    {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }
  );
};

export const formatFileSize = (
  bytes: number
) => {
  if (!bytes) return '-';

  const units = [
    'Bytes',
    'KB',
    'MB',
    'GB',
    'TB',
  ];

  let size = bytes;
  let unitIndex = 0;

  while (
    size >= 1024 &&
    unitIndex < units.length - 1
  ) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${
    units[unitIndex]
  }`;
};

export const getTitleColor = (title: string) => {
  switch (title) {
    case 'Input Files':
      return '#1976d2'; // Blue
    case 'Output Files':
      return '#2e7d32'; // Green
    case 'Error Files':
      return '#d32f2f'; // Red
    default:
      return '#000';
  }
};

export const isValidFileName = (fileName: string) => {
  return /^[a-zA-Z0-9 _.-]+$/.test(fileName);
};

export const getStatusMessage = (status: string,   hasUploadedFile: boolean) => {
  switch (status?.toLowerCase()) {
    case 'idle':
      return hasUploadedFile
        ? 'No active processing was detected. If your file is still being processed, click Refresh Status.'
        : 'Upload a file to begin processing.';

    
    case 'uploading':
      return 'File uploaded successfully. Waiting for Lambda to start processing...';

    case 'pending':
      return 'Your file is waiting to be processed...';

    case 'provisioning':
      return 'Preparing processing environment...';

    case 'running':
      return 'Processing your file...';

    case 'deprovisioning':
      return 'Finalizing processing...';

    case 'success':
      return 'File processed successfully.';

    case 'failed':
      return 'Processing failed. Please check Error Files.';

    case 'timeout':
      return 'Processing is taking longer than expected. Click Refresh Status to continue checking.';

    default:
      return 'Checking processing status... Please wait.';
  }
};

export const getAlertSeverity = (
  status: string
): 'success' | 'info' | 'warning' | 'error' => {
  switch (status?.toLowerCase()) {
      case 'idle':
      return 'info';

    case 'success':
      return 'success';

    case 'failed':
      return 'error';

    case 'pending':
    case 'provisioning':
      return 'warning';

    default:
      return 'info';
  }
};

export const getExecutionStatusError = (error: any) => {
  const message =
    error?.response?.error ||
    error?.response?.message ||
    error?.message ||
    '';

  console.error('Execution Status Error:', message);

  if (message.includes('Unknown module')) {
    return 'The selected import module could not be found. Please select a valid folder and try again.';
  }

  if (
    message.includes('AccessDenied') ||
    message.includes('DescribeTasks') ||
    message.includes('ListTasks')
  ) {
    return 'Unable to retrieve the processing status at the moment. Please try Refresh later or contact your administrator.';
  }

  if (message.includes('Network Error')) {
    return 'Unable to connect to the server. Please check your network connection.';
  }

  return 'Unable to retrieve the processing status. Please try again later.';
};